import { Divider, Modal, Spin } from 'antd';
import styled from 'styled-components';

export const ModalCreateComposition = styled(Modal)`
    .ant-modal-body {
        padding: 0;
    }
    .ant-modal-close {
        display: none;
    }
    .ant-modal-content {
        border-radius: 8px;
    }

    @media (max-width: 991px) {
        .create-composition-card {
            align-items: flex-start;

            .ant-col {
                min-height: unset;
            }

            .col-details-color {
                flex: 0 0 100% !important;
                max-width: 100% !important;
                margin-top: 4px;

                p {
                    display: flex;
                    flex-direction: column;
                    gap: 2px;
                }
            }

            .product-info-packing {
                flex: 0 0 100% !important;
                max-width: 100% !important;
            }

            .package-select {
                max-width: 100%;

                .ant-select-selector {
                    min-height: 28px;
                    display: flex;
                    align-items: center;
                }
            }

            .ant-select-selection-item {
                line-height: 18px;
            }

            .line-break-mobile {
                display: none;
            }

            .ant-row {
                row-gap: 8px;
            }

            .ant-col-7,
            .ant-col-md-7,
            .ant-col-lg-7,
            .ant-col-xl-7 {
                margin-top: 4px;
            }

            .line-actions,
            .line-actions-input,
            .line-actions-quantity {
                justify-content: flex-start;
            }

            .line-actions-input .input-quantity {
                width: 100%;
            }
        }
    }

    @media (max-width: 575px) {
        .create-composition-card {
            .row-details > .ant-col {
                flex: 0 0 100% !important;
                max-width: 100% !important;
                margin-bottom: 8px;
            }

            .group-information .title {
                line-height: 14px;
            }

            .group-information .package-select {
                margin-top: 2px;
            }

            .line-actions,
            .line-actions-input,
            .line-actions-quantity {
                width: 100%;
            }

            .line-actions {
                margin-top: 4px;
            }
        }
    }
`;

export const Loader = styled(Spin)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
`;

export const Overlay = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 2;
  cursor: pointer;
`;

export const ModalHeaderCreateComposition = styled.div`
    height: 100%;   
    display: flex;
    flex-direction: column;   
    padding: 20px;

    border-top-right-radius: 8px;
    border-top-left-radius: 8px;
    background-color: #f78e1e;

    span {
        color: #fff;
        font-size: 22px;
        line-height: 20px;
        font-weight: 500;
    }
    p {
        color: #fff;
        font-size: 16px;
        line-height: 20px;
        font-weight: 400;

        padding: 0;
        margin-bottom: 0;
        margin-top: 12px;
    }

    .info-row {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        flex-wrap: wrap;
        margin-top: 8px;

        span {
            font-size: 14px;
            font-weight: 400;
            line-height: 20px;
        }
    }

    .info-separator {
        opacity: 0.7;
    }

    @media (max-width: 991px) {
        padding: 16px;

        span {
            font-size: 18px;
        }
        p {
            font-size: 14px;
            margin-top: 8px;
        }

        .info-row {
            flex-direction: column;
            align-items: flex-start;
            gap: 2px;
            margin-top: 6px;

            span {
                font-size: 12px;
                line-height: 18px;
            }
        }

        .info-separator {
            display: none;
        }
    }
`;

export const ModalBodyCreateComposition = styled.div`
    .cards {
        max-height: 550px;
        width: 100%;
        overflow: auto;
    }

    @media (max-width: 991px) {
        .cards {
            max-height: 60vh;
        }
    }
`;

export const ModalFooterCreateComposition = styled.div`
    width: 100%;
    padding:  8px 40px;

    @media (max-width: 991px) {
        padding: 8px 16px;
    }
`;

export const ModalFooterInformations = styled.div`
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
`;
export const ModalFooterInformationText = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content:space-between;
    margin-bottom: 8px; 
    > p {
        text-align: start;
        margin: 0;
        margin-right: 8px;
        padding-bottom: 16px;
        margin-bottom: -3px;
        color: #8c8c8c;
        font-size: 14px;
        line-height: 22px;
        font-weight: 400;
    } 
    > span {
        text-align: start;
        color: #353839;
        padding-bottom: 16px;      
        font-size: 20px;
        line-height: 24px;
        font-weight: 700;
    }
    @media (max-width: 991px) {
        > span {
            font-size: 16px;
            line-height: 20px;
        }
    }
`;
export const ModalFooterActions = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
`;

export const CardDivider = styled(Divider)`
    margin: 0;
`;
